import { ExtensionType, GeneratedAnimalName } from '../types/ExtensionCard';
import { GameStage, HandType } from '../types/roomState';

export const SUPPORTED_LOCALES = ['en', 'ru'] as const;

export type Locale = typeof SUPPORTED_LOCALES[number];

export type MessagePrimitive = string | number | boolean | null | undefined;

export type BaseMessageDescriptor<Key extends string = string> = {
  key: Key;
  values?: MessageValues<Key>;
};

export type MessageValue<Key extends string = string> =
  | MessagePrimitive
  | BaseMessageDescriptor<Key>;

export type MessageValues<Key extends string = string> = Record<
  string,
  MessageValue<Key>
>;

export type ResolvedMessageValues = Record<
  string,
  string | number | boolean | undefined
>;

export type MessageFormatter = (values: any, locale: Locale) => string;

export type CardMessageField = 'name' | 'description' | 'shortName';

export type CardMessageKey = `card.${ExtensionType}.${CardMessageField}`;
export type StageMessageKey = `stage.${GameStage}`;
export type HandTypeMessageKey = `handType.${HandType}`;
export type GeneratedAnimalNameMessageKey =
  `animal.generated.${GeneratedAnimalName}`;
